import { useAtom }   from "jotai";
import { useEffect } from "react";

import { initialValidations }                 from "_common/ssrWrapper";
import { formatReel }                         from "_common/utils/broadcast";
import { getFormattedData }                   from "_common/utils/results";
import Results                                from "_components/pages/results";
import { updateSearchTerm }                   from "_jotai/search.js";
import { getSearchTabResults, getSearchTabs } from "_services/api/feed";

const results = props => {
	const { search_query, tab, tabs, initialData, previousPath } = props;
	const [ , updateSearch ]                                     = useAtom ( updateSearchTerm );

	useEffect ( () => {

		if ( search_query ) {
			updateSearch ( search_query );
		}

		return () => {
			updateSearch ( "" );
		};
	}, [] );

	return (
		<Results
			initialData  = { initialData }
			previousPath = { previousPath }
			search_query = { search_query }
			tab          = { tab }
			tabs         = { tabs }
		/>
	);
};

const getServerSideProps = async context => initialValidations ( context, async ( defaultProps, context ) => {

	let activeTab = "all";

	const { query, tab } = context.query;

	if ( tab )
		activeTab = tab;

	const results = await Promise.allSettled (
		[
			getSearchTabs.bind ( defaultProps ) (),
			getResultsWithTopProfile.bind ( defaultProps ) ( { searchQuery: query, key: activeTab, pageNo: 1 } )
		]
	);

	let tabs        = [], initialData = null;
	let forceLogout = false;

	results.forEach ( ( result, index ) => {
		if ( result.status === "fulfilled" ) {
			switch ( index ) {
				case 0:
					tabs = result.value;
					break;

				case 1:
					initialData = result.value;
					break;
			}
		}

		if ( result.status === "rejected" && result.reason?.message === "TOKEN_EXPIRED_FORCE_LOGOUT" )
			forceLogout = true;
	} );

	if ( forceLogout )
		return {
			redirect: {
				destination : `/logout?forceLogout=${ true }&prevLocation=${ defaultProps?.currentPath }`,
				permanent   : false
			}
		};

	/* context.res.setHeader (
    "Cache-Control",
    "public, s-maxage=10, stale-while-revalidate=59"
  ); */

	return {
		props: {
			...defaultProps,
			noLayout     : defaultProps?.isMobile ? true : false,
			tabs,
			initialData,
			search_query : query,
			tab          : activeTab
		}
	};
} );

export { getServerSideProps };

export default results;

export const getResultsWithTopProfile = async function ( params ) {
	const { searchQuery, key } = params;
	const response             = await getSearchTabResults.bind ( this ) ( params, searchQuery );
	let formatedReels          = [];

	if ( key === "all" ) {
		if ( !key || !searchQuery )
			return [];

		const { mergedVideos, topCreator, reels } = response;

		if ( reels.length > 0 ) {
			formatedReels = reels.map ( formatReel );
		}

		if ( mergedVideos?.length > 0 ) {
			const formattedMergedVideos = getFormattedData ( mergedVideos );

			return { formattedMergedVideos, topCreator, formatedReels };
		} else {
			return { mergedVideos, topCreator, formatedReels };
		}
	}
	if ( key === "videos" || key === "liveStreams" ) {
		const formattedData = getFormattedData ( response );

		return formattedData;
	}

	if ( key === "reels" ) {
		const formatedReels = response.map ( formatReel );

		return formatedReels;
	}

	return response;

};
